export default (from_search) => {
  const prefix = (from_search) ? 'overlay-search-' : '';

  const setMenuItemExpandedState = ($menuItem, isOpen) => {
    $menuItem.toggleClass('active', isOpen);

    const $button = $menuItem.find(`[data-${prefix}filter-button]`).first();
    if ($button.length) {
      $button.attr('aria-expanded', String(isOpen));
    }

    const $panel = $menuItem.find(`[data-${prefix}filter-options-container]`).first();
    if ($panel.length) {
      $panel.attr('aria-hidden', String(!isOpen));
    }
  };

  const focusMenuItemOption = ($menuItem, mode = 'first') => {
    const $optionItems = $menuItem.find('[data-clickable-option]');
    if (!$optionItems.length) {
      return false;
    }

    setMenuItemExpandedState($menuItem, true);
    const $focusTarget = mode === 'last' ? $optionItems.last() : $optionItems.first();
    $focusTarget.trigger('focus');
    return true;
  };

  const getSiblingMenuItems = ($menuItem) => {
    const $siblings = $menuItem.parent().children(`[data-${prefix}filter-options]`);
    return $siblings.length ? $siblings : $menuItem.siblings(`[data-${prefix}filter-options]`).addBack();
  };

  const setFocusToNextMenuItem = ($item) => {
    const $menuItems = getSiblingMenuItems($item);
    const element_index = $menuItems.index($item);
    if (element_index === -1) {
      return;
    }

    for (let i = element_index + 1; i < $menuItems.length; i += 1) {
      const $nextMenuItem = $menuItems.eq(i);
      if (focusMenuItemOption($nextMenuItem, 'first')) {
        return;
      }
    }

    // Desktop fallback: when no next filter group exists, move to sorting.
    $(`[data-${prefix}show-desktop-sort-nav]`).trigger('click');
  };

  const setFocusToPreviousMenuItem = ($item) => {
    const $menuItems = getSiblingMenuItems($item);
    const element_index = $menuItems.index($item);
    if (element_index === -1) {
      return;
    }

    for (let i = element_index - 1; i >= 0; i -= 1) {
      const $previousMenuItem = $menuItems.eq(i);
      if (focusMenuItemOption($previousMenuItem, 'last')) {
        return;
      }
    }
  };

  // const setFocusToFirstSubMenuItem = ($item) => { 
  //   $item.find(`[data-${this.prefix}clickable-option-li]`).first().find('[data-clickable-option]').trigger('focus');
  // };

  const setFocusToNextSubMenuItem = ($item) => {
    const total_items_in_element = $item.closest(`[data-${prefix}filter-options-items]`).find('li').length;
    const element_index = $item.parent().index();
    // console.log('total_items_in_element', total_items_in_element);
    // console.log(`setFocusToNextSubMenuItem element_index width value ${$item.data('option-value')}`, element_index);

    if (element_index + 1 < total_items_in_element) {
      $item.closest(`[data-${prefix}filter-options-items]`).find('li').eq(element_index + 1).find(`[data-clickable-option]`).trigger('focus');
    } else {
      // Go to next menu item
      setFocusToNextMenuItem($item.closest(`[data-${prefix}filter-options]`));
    }
  };

  const setFocusToPreviousSubMenuItem = ($item) => {
    const element_index = $item.parent().index();
    // console.log(`setFocusToPreviousSubMenuItem element_index width value ${$item.data('option-value')}`, element_index);

    if (element_index - 1 >= 0) {
      $item.closest(`[data-${prefix}filter-options-items]`).find('li').eq(element_index - 1).find(`[data-clickable-option]`).trigger('focus');
    } else {
      // Go to previous menu item
      setFocusToPreviousMenuItem($item.closest(`[data-${prefix}filter-options]`));
    }
  };

  // Select a subnav menu item
  $(document).on('keydown', `[data-${prefix}filter-options] [data-clickable-option]`, (e) => {
    const key = e.key || '';
    const keyCode = e.which || e.keyCode;
    const $item = $(e.currentTarget);
    const isEnter = key === 'Enter' || keyCode === 13;
    const isSpace = key === ' ' || key === 'Spacebar' || keyCode === 32;
    const isLeft = key === 'ArrowLeft' || keyCode === 37;
    const isUp = key === 'ArrowUp' || keyCode === 38;
    const isRight = key === 'ArrowRight' || keyCode === 39;
    const isDown = key === 'ArrowDown' || keyCode === 40;

    if (isEnter || isSpace) {
      // Space should not scroll the page; both keys should toggle the option.
      e.preventDefault();
      $item.trigger('click');
      return;
    }

    if (isLeft || isUp) {
      e.preventDefault();
      setFocusToPreviousSubMenuItem($item);
      return;
    }

    if (isRight || isDown) {
      e.preventDefault();
      setFocusToNextSubMenuItem($item);
    }
  });

  $(document).on('change', '[data-option-ada]', (e) => {
    const $item = $(e.currentTarget);
    $item.closest('.newfilter-checkbox').trigger('click');
    // if ($item.checked) {
    //   // checkbox is checked
    // }
  });

  $(document).on('keypress', `[data-${prefix}show-desktop-filter-nav]`, (e) => {
    const key = e.which;

    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });
};
